import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class TeamService {
  constructor(private http: HttpClientService) {}

  public resume({
    start = undefined,
    end = undefined,
    stages = undefined,
    compare = undefined,
    count = undefined,
    group_period = undefined,
    group_by = undefined,
    show = undefined,
    filter_ids = undefined,
  }): Observable<any> {
    const options = {
      params: {
        count: count,
        start: start,
        end: end,
        group_period: group_period,
        group_by: group_by,
        show: show,
        "stages[]": stages,
        "compare[]": compare,
        "filter_ids[]": filter_ids,
      },
    };
    return this.http.get("/api/teams/resume", options).pipe(tap((_) => console.log("TeamsService.resume: Ok.")));
  }

  public getTeams(include = null): Observable<any> {
    const options = {
      params: {
        include: include,
      },
    };
    return this.http.get("/api/teams", options).pipe(tap((_) => console.log("TeamsService.getTeams: Ok.")));
  }

  public getUsers(team_id: number): Observable<any> {
    return this.http
      .get("/api/teams/" + team_id + "/users")
      .pipe(tap((_) => console.log("TeamsService.getUsers: Ok.")));
  }

  public putSkills(team_id: number, users: [{ id: number; skill: string }]): Observable<any> {
    let options = {
      users: users,
    };
    return this.http
      .put("/api/teams/" + team_id + "/skills", options)
      .pipe(tap((_) => console.log("TeamsService.putSkills: Ok.")));
  }

  public getTeam(team_id: number): Observable<any> {
    return this.http.get("/api/teams/" + team_id).pipe(tap((_) => console.log("TeamsService.getTeam: Ok.")));
  }

  public updateTeam(team_id: number, body: { legal_representative_id?: number | null }): Observable<any> {
    return this.http.patch("/api/teams/" + team_id, { team: body });
  }

  public getRegionalManaged(id: number): Observable<any> {
    return this.http
      .get("/api/users/" + id + "/teams/regional_managed")
      .pipe(tap((_) => console.log("TeamsService.getManagedTeam: Ok.")));
  }
  public getManaged(id: number): Observable<any> {
    return this.http
      .get("/api/users/" + id + "/teams/managed")
      .pipe(tap((_) => console.log("TeamsService.getManaged: Ok.")));
  }
}
